import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Sparkles } from "lucide-react";
import LeadForm from "./LeadForm";

export default function EnrollDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="enroll-dialog"
        className="sm:max-w-md bg-white border-border p-0 overflow-hidden"
      >
        <div className="px-6 pt-6 pb-2 bg-primary text-white">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] opacity-90">
            <Sparkles className="h-3.5 w-3.5" />
            Admissions Open · 2026 Batch
          </div>
          <DialogHeader className="mt-2 space-y-1 text-left">
            <DialogTitle className="font-display text-2xl font-medium text-white">
              Reserve your seat
            </DialogTitle>
            <DialogDescription className="text-white/80">
              Drop your details — a counsellor will call you back today.
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="px-6 py-6">
          <LeadForm variant="light" testidPrefix="enroll" submitLabel="Submit & get a call back" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
